import { analyticsEventAttributes as analyticsEventAttributesDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    metric?: string;
}

export const analyticsEventAttributes = ({
    metric,
}: Props) => analyticsEventAttributesDiagram({metric});
